import { createStore } from "vuex";

const defaultSiteConfig = {
  servicePhone: "400-XXX-XXXX",
  serviceEmail: "service@icka.cn",
  workTime: "工作日 9:00-18:00",
  copyright: "Copyright © 2026 电子口岸IC卡 · All Rights Reserved",
  icpNumber: "沪ICP备XXXXXXXX号-1",
  privacyPolicyUrl: "",
  termsUrl: "",
  paymentEnabled: false,
  seoTitle: "电子口岸IC卡在线制卡服务平台 - icka.cn",
  seoKeywords: "电子口岸IC卡,电子口岸法人IC卡,电子口岸操作员IC卡,海关IC卡,海关IC卡申请",
  seoDescription:
    "电子口岸IC卡在线制卡平台是一个高效、便捷的在线服务平台，旨在为企业和个人提供电子口岸IC卡的申请、制作与管理服务。该平台依托现代信息技术，通过官方网站或移动应用，实现了IC卡的在线申请、信息填写、资料提交、审核进度查询及后续激活使用等全流程服务。用户无需前往实体服务中心，即可快速完成IC卡的申请与获取，大大节省了时间和成本。",
  orderCloseHours: 48,
};

export default createStore({
  state: {
    loadingState: false,
    siteConfig: { ...defaultSiteConfig },
  },
  getters: {
    getLoadingState(state) {
      return state.loadingState;
    },
    getSiteConfig(state) {
      return state.siteConfig;
    },
  },
  mutations: {
    setLoadingState(state, payload) {
      state.loadingState = payload;
    },
    setSiteConfig(state, payload) {
      state.siteConfig = {
        ...defaultSiteConfig,
        ...payload,
      };
    },
  },
  actions: {},
  modules: {},
});
